import { Component } from '@angular/core';

@Component({
    selector: 'error-network',
    templateUrl: './network.component.html',
    styles: [],
    standalone: false
})
export class NetworkComponent {
    constructor() { }
}